(function (window) {
  'use strict';

  var DEFAULT_API_BASE_URL = 'https://erp-achat.vercel.app/';
  var DEFAULT_LOCALE = 'fr';
  var DEFAULT_SELL_BIKE_URL = '/pages/formulaire-reprise';

  window.buybackPortalConfig = {
    get: function () {
      return window.buybackPortal || {};
    },
    getApiBaseUrl: function () {
      var cfg = window.buybackPortal || {};
      return cfg.apiBaseUrl || DEFAULT_API_BASE_URL;
    },
    getLocale: function () {
      var cfg = window.buybackPortal || {};
      return cfg.locale || DEFAULT_LOCALE;
    },
    getContactPhone: function () {
      return (window.buybackPortal || {}).contactPhone || '';
    },
    getContactEmail: function () {
      return (window.buybackPortal || {}).contactEmail || '';
    },
    getSellBikeUrl: function () {
      return (window.buybackPortal || {}).sellBikeUrl || DEFAULT_SELL_BIKE_URL;
    },
  };
})(window);
